export default function Subtitle({ title }) {
  return <h2 className=" text-gray-900 text-xl font-medium">{title}</h2>;
}
